module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "fm3"
    }
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_vm._v("sabotage… "), _c('em', [_vm._v("n")]), _vm._v(". [Fr. < "), _c('em', [_vm._v("sabot")]), _vm._v(", wooden shoe + −"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE:")]), _vm._v(" from damage done to machinery by sabots]….")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("Webster’s New World Dictionary")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f3ae4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_fm3_r1.vue
// module id = 78
// module chunks = 0